export default __webpack_public_path__ + "static/media/pause.602f0578.png";